import React from 'react'
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import Langs, { Localize } from "../../app/lang/langs";
import { Row, Col } from 'react-bootstrap';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Tag } from 'primereact/tag';
import moment from 'moment';

export function InputField(props) {

    const handleChange = (e) => {
        if (!props.onChange || !props.field || props.field.disabled)
            return
        switch (props.field.type) {
            case "text":
            case "string":
                props.onChange(e.target.value)
                break
            default:
                props.onChange(e.value)
                break
        }
    }

    const errorClass = props.error ? 'p-invalid' : ''

    function renderField() {
        switch (props.field.type) {
            case "string":
                if (props.field.disabled)
                    return <span>{props.value}</span>
                return <InputText value={props.value}
                    disabled={props.field.disabled} 
                    onChange={handleChange}
                    className={errorClass}
                />
            case "text":
                if (props.field.disabled)
                    return <p style={{ whiteSpace: "pre-line" }}>{props.value}</p>
                return <InputTextarea value={props.value}
                    style={{ whiteSpace: "pre-line", ...(props.error ? { borderColor: 'var(--red-500)' } : {}) }}
                    onChange={handleChange}
                    autoResize={props.field.auto}
                    disabled={props.field.disabled}
                    rows={props.field.rows}
                    cols={props.field.cols}
                    className={errorClass}
                />
            case "date":
                if (props.field.disabled)
                    return <p>{moment(props.value).format("DD/MM/YYYY")}</p>
                return <Calendar
                    disabled={props.field.disabled}
                    dateFormat="dd/mm/yy"
                    placeholder='dd/mm/yyyy'
                    value={props.value && new Date(props.value)}
                    onChange={handleChange}
                    showButtonBar={props.field.showButtonBar}
                    className={errorClass}
                />
            case "dropdown":
                return <Dropdown
                    options={props.field.options}
                    value={props.value}
                    optionLabel={props.field.optionLabel}
                    optionValue={props.field.optionValue}
                    onChange={handleChange}
                    filter={props.field.filter}
                    showClear={props.field.showClear}
                    disabled={props.field.disabled}
                    placeholder={Localize(props.field.placeholder)}
                    valueTemplate={props.field.valueTemplate}
                    itemTemplate={props.field.itemTemplate}
                    className={errorClass}
                />
            case "date:time":
                if (props.field.disabled)
                    return <p>{moment(props.value).format("DD/MM/YYYY HH:mm")}</p>
                return <Calendar
                    disabled={props.field.disabled}
                    dateFormat="dd/mm/yy"
                    placeholder='dd/mm/yyyy HH:mm'
                    showTime
                    value={props.value && new Date(props.value)}
                    onChange={handleChange}
                    className={errorClass}
                />
            case "yes:no":
                return <Dropdown value={Localize(props.value)}
                    disabled={props.field.disabled}
                    options={["yes", "no"]}
                    onChange={handleChange}
                    valueTemplate={yesNoBodyTemplate}
                    itemTemplate={yesNoBodyTemplate}
                    className={errorClass}
                />
            case "number":
                return <InputNumber value={props.value}
                    min={props.field.min}
                    max={props.field.max}
                    disabled={props.field.disabled}
                    onChange={handleChange}
                    maxFractionDigits={props.field.maxFractionDigits}
                    showButtons
                    className={errorClass}
                />
            default:
                return <span>{props.value}</span>
        }
    }

    const yesNoBodyTemplate = (option) => {
        switch (option) {
            case "yes":
                return <Tag value={<Langs str="yes" />} severity="success" />
            case "no":
                return <Tag value={<Langs str="no" />} severity="danger" />
            default:
                return <Tag value="Inconnu" severity="danger" />
        }
    }

    return <Row>
        <Col xl={3} className="mb-3 pe-3 p-fluid align-items-center">
            <label className="fw-bold" style={props.error ? { color: 'var(--red-500)' } : undefined}>
                {props.field.InputFieldLabel ? <Langs str={props.field.InputFieldLabel} />
                    : <Langs str={props.field.key} />}
            </label>
        </Col>
        <Col xl={9} className="mb-3 pe-3 p-fluid">
            {renderField()}
        </Col>
    </Row>
}